import { Component, ojs, app, state, v } from "modular-openscriptjs";
import { pageInfo, either, scrollToTop } from "../../../helpers";
import { api } from "../../../declarations";
import SolidIcon from "../../Blocks/SolidIcon";

const h = app("h");
const router = app("router");
ojs(SolidIcon);

export default class ManageBusiness extends Component {
    business = state(null);
    businessId = null;

    constructor() {
        super();
        this.businessId = window.currentCompany?.id;
    }

    render() {
        scrollToTop();

        if (!this.business.value) {
            this.fetchBusiness();
        }

        return h.div(
            { class: "min-vh-100 py-5 mb-5 py-md-5" },
            h.div(
                { class: "container" },
                v(this.business, (b) => {
                    if (!b.value) return h.div({ class: "text-center py-5" }, h.Spinner());
                    
                    pageInfo(`Manage ${b.value.name}`);

                    return h.div(
                        {},
                        h.div(
                            { class: "mb-4 d-flex align-items-center gap-3" },
                            h.button(
                                { class: "btn btn-white border shadow-sm rounded-circle p-2", onclick: "history.back()" },
                                h.SolidIcon("arrow-left")
                            ),
                            h.h2({ class: "fw-bold mb-0" }, `Manage ${b.value.name}`)
                        ),

                        h.div(
                            { class: "row g-4" },
                            this.renderMenuCard(
                                "Primary Information",
                                "Edit business name and basic details.",
                                "info-circle",
                                "primary",
                                h.func("app('router').to", "business.manage.primary", { companyId: this.businessId })
                            ),
                            this.renderMenuCard(
                                "Support Information",
                                "Manage how customers contact you.",
                                "headset",
                                "success",
                                h.func("app('router').to", "business.manage.support", { companyId: this.businessId })
                            ),
                            this.renderMenuCard(
                                "Branches",
                                "Manage your physical locations and staff.",
                                "shop",
                                "info",
                                h.func("app('router').to", "business.manage.branches", { companyId: this.businessId })
                            ),
                            this.renderMenuCard(
                                "Legal Information",
                                "Business registration and terms.",
                                "file-earmark-text",
                                "warning",
                                h.func("app('router').to", "business.manage.legal", { companyId: this.businessId })
                            ),
                            this.renderMenuCard(
                                "Staff Management",
                                "Manage business administrators and staff.",
                                "people",
                                "danger",
                                h.func("app('router').to", "business.manage.staff", { companyId: this.businessId })
                            ),
                            this.renderMenuCard(
                                "Reviews & Ratings",
                                "See what customers are saying.",
                                "star",
                                "dark",
                                h.func("app('router').to", "business.reviews", { companyId: this.businessId })
                            )
                        )
                    );
                })
            )
        );
    }

    renderMenuCard(title, description, icon, color, onclick) {
        return h.div(
            { class: "col-12 col-md-6 col-lg-4", role: 'button' },
            h.div(
                { 
                    class: "card border-0 shadow-sm h-100 cursor-pointer hover-shadow transition", 
                    onclick: onclick,
                    style: "border-radius: 20px;"
                },
                h.div(
                    { class: "card-body p-4" },
                    h.div(
                        { class: `bg-${color}-subtle text-${color} rounded-4 d-inline-flex p-3 mb-3` },
                        h.i({ class: `bi bi-${icon} fs-3` })
                    ),
                    h.h5({ class: "fw-bold mb-2" }, title),
                    h.p({ class: "text-muted small mb-0" }, description)
                )
            )
        );
    }

    async fetchBusiness() {
        try {
            const res = await api.get(`companies/${this.businessId}`);
            if (res) {
                this.business.value = res.data.company;
            }
        } catch (e) {
            console.error(e);
        }
    }
}

ojs(ManageBusiness);
